import globalToast from "../components/common/globalToast";
import api from "../services/api";

const service_path = '/platings.php';

export function getPlatings() {

    const response = api.get(service_path);

    return response;
};

export function getPlatingDetails(id) {
    return api.get(`${service_path}?id=${id}`);
}

export function createPlating(data, navigateBack) {

    api.post(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Banho cadastrado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function updatePlating(data, navigateBack) {

    api.patch(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Banho editado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function deletePlating(id, user_id) {
    api.delete(service_path, { data: { id, user_id } })
        .then(response => {
            const { data } = response;
            if (data.success) {
                globalToast.success("Banho deletado com sucesso!")
            } else {
                globalToast.error('Houve um erro ao deletar o banho!');
            };
        });
};  